export default __webpack_public_path__ + "static/media/order_sent.4d00a577.jpg";